import { DatePicker, Form, Input, Radio, Select } from "antd";
import React, { useRef } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { GenderData, nationalityData, YesNoData } from "../../../../data";
import svg92 from "../../../../assets/svg/svg92.svg";
import svg85 from "../../../../assets/svg/svg85.svg";
import PhoneInput from "react-phone-input-2";
import dayjs from "dayjs";

function PersonalInformation({ handleNext, handleBack, form }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handlePrev = async () => {
    await navigate("/recruitment/career-view-list");
  };

  const today = new Date();
  let dd = String(today.getDate()).padStart(2, 0);
  let mm = String(today.getMonth() + 1).padStart(2, 0);
  let yyyy = today.getFullYear() - 18;

  let minDate = `${yyyy}-${mm}-${dd}`;

  async function handleSubmitStep() {
    try {
      await form.validateFields([
        "japFirstName",
        "japLastName",
        "japEmail",
        "japPhone",
        "japAddress",
        "japDob",
        "japGender",
        "japNationality",
        "japIsPLWD",
      ]);
      await handleNext();
    } catch {}
  }

    const plainOptions = [
    { label: "Yes", value: true },
    { label: "No", value: false },
  ];

  return (
    <>
      <div className="text-lightBlack text-[1.125rem] font-dmSans font-500">
        Personal Information
      </div>
      <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10 mt-[1.5rem]">
        <Form.Item
          name="japFirstName"
          label={"First Name"}
          rules={[
            {
              required: true,
              message: "Please add first Name",
            },
          ]}
        >
          <Input className="input" />
        </Form.Item>
        <Form.Item
          name="japLastName"
          label={"Last Name"}
          rules={[
            {
              required: true,
              message: "Please add last Name",
            },
          ]}
        >
          <Input className="input" />
        </Form.Item>
        <Form.Item
          name="japEmail"
          label="Email"
          rules={[
            {
              required: true,
              message: "Email is required to login",
            },
            {
              type: "email",
              message: "Please enter a valid email address",
            },
          ]}
        >
          <Input type="email" className="input" />
        </Form.Item>
        <Form.Item
          label="Phone"
          name="japPhone"
          validateFirst
          rules={[
            {
              required: true,
              message: "Phone number is required",
            },
            {
              validator: (_, value) => {
                if (value && value.length >= 12) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error(
                    "Phone number must be exactly 10 characters excluding country code"
                  )
                );
              },
            },
          ]}
        >
          <PhoneInput
            enableSearch
            country="ke"
            countryCodeEditable={false}
            className="input"
          />
        </Form.Item>
        <Form.Item
          name="japAddress"
          label={"Address"}
          rules={[
            {
              required: true,
              message: "Please add address",
            },
          ]}
        >
          <Input className="input" />
        </Form.Item>
        <Form.Item
          name="japDob"
          rules={[
            {
              required: true,
              message: "Field is required",
            },
          ]}
          label="Date of Birth"
        >
          <DatePicker
            maxDate={dayjs(minDate)}
            format={"YYYY MMM DD"}
            className="input"
          />
        </Form.Item>
        <Form.Item
          name="japGender"
          className=""
          label={"Gender"}
          rules={[
            {
              required: true,
              message: "Please select gender",
            },
          ]}
        >
          <Select
            className=""
            allowClear
            style={{
              width: "100%",
            }}
            options={
              GenderData?.length > 0 &&
              GenderData?.map((item) => ({
                value: item?.label,
                label: item?.label,
              }))
            }
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label?.toLocaleLowerCase() ?? "").includes(
                input?.toLocaleLowerCase()
              )
            }
          />
        </Form.Item>
        <Form.Item
          name="japNationality"
          className=""
          label={"Nationality"}
          rules={[
            {
              required: true,
              message: "Please select nationality",
            },
          ]}
        >
          <Select
            className=""
            allowClear
            style={{
              width: "100%",
            }}
            options={
              nationalityData?.length > 0 &&
              nationalityData?.map((item) => ({
                value: item?.value,
                label: item?.label,
              }))
            }
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label?.toLocaleLowerCase() ?? "").includes(
                input?.toLocaleLowerCase()
              )
            }
          />
        </Form.Item>

         <Form.Item
          label={"Are you PLWD?"}
          rules={[
            {
              required: true,
              message: "Please select are you PLWD?",
            },
          ]}
          name="japIsPLWD"
        >
          <Radio.Group options={plainOptions} />
        </Form.Item>

         
      </div>

      <div className="flex lg:flex-row flex-col lg:items-center justify-between lg:gap-0  gap-5 w-full mt-[1.5rem]">
        <div
          className="flex items-center text-[#706F6F] text-[.875rem] font-[400] font-dmSans gap-3 cursor-pointer"
          onClick={() => handlePrev()}
        >
          <img src={svg85} alt="svg85" /> Back
        </div>
        <div className="justify-end flex items-center gap-x-2">
          <div className="w-[100px]">
            <button
              key="back"
              type="button"
              className="cstm-btn-2"
              onClick={() => handlePrev()}
            >
              Cancel
            </button>
          </div>

          <div className="w-[230px]">
            <button
              key="submit"
              type="submit"
              className="cstm-btn"
              onClick={handleSubmitStep}
            >
              <span className="flex items-center  gap-x-3 ">
                Save And Proceed <img src={svg92} alt="svg92" />
              </span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default PersonalInformation;
